export default class CustomColumnsViewModel {
    public wseNumber: boolean = true;
    public revisionNumber: boolean = true;
    public client: boolean = false;
    public plant: boolean = false;
    public site: boolean = false;
    public assetType: boolean = false;
    public designCode: boolean = false;
    public description: boolean = false;
    public plantItemNumber: boolean = false;
    public serialNumber: boolean = false;
    public service: boolean = false;
    public pids: boolean = false;
    public pssr: boolean = false;
    public dateOfFabrication: boolean = false;

    // Components
    public componentName: boolean = false;
    public componentMaterial: boolean = false;
    public componentNominalThickness: boolean = false;
    public componentDesignPressure: boolean = false;
    public componentDesignTemperatureRange: boolean = false;
    public componentFluidService: boolean = false;
    public componentOperatingPressure: boolean = false;
    public componentOperatingTemperature: boolean = false;
    public componentCorrosionAllowance: boolean = false;

    // Component pressure vessel
    public componentOtherComments: boolean = false;

    // Component relief system
    public componentManufacturer: boolean = false;
    public componentModel: boolean = false;
    public componentSerialNumber: boolean = false;
    public componentConventionalBellowsPilot: boolean = false;
    public componentSetPressure: boolean = false;
    public componentReliefFrom: boolean = false;
    public componentReliefTo: boolean = false;
    public componentEquipmentProtected: boolean = false;

    // Safety Devices
    public safetyType: boolean = false;
    public safetyEquipmentNumber: boolean = false;
    public safetyColdDifferential: boolean = false;
    public safetyReliefSystemWse: boolean = false;

    // Damage mechanisms
    public damageName: boolean = false;
    public damageLocation: boolean = false;
    public damagePreparation: boolean = false;
    public damageInspectionRequirement: boolean = false;

    // Inspections
    public thoroughNotes: boolean = false;
    public thoroughInterval: boolean = false;
    public intermediateAReqs: boolean = false;
    public intermediateAInterval: boolean = false;
    public intermediateBReqs: boolean = false;
    public intermediateBInterval: boolean = false;
    public oneOffReqs: boolean = false;
}